export const SUCCESS_MESSAGE_EVENT = 'upskill:success-message';
export const WARNING_MESSAGE_EVENT = 'upskill:warning-message';
export const LOADING_MESSAGE_EVENT = 'upskill:loading-message';
export const CLEAR_MESSAGE_EVENT = 'upskill:clear-message';

export const showSuccessMessage = (message) => {
  window.dispatchEvent(new CustomEvent(SUCCESS_MESSAGE_EVENT, { detail: message }));
};

export const showWarningMessage = (message) => {
  window.dispatchEvent(new CustomEvent(WARNING_MESSAGE_EVENT, { detail: message }));
};

export const showLoadingMessage = (message) => {
  window.dispatchEvent(new CustomEvent(LOADING_MESSAGE_EVENT, { detail: message }));
};

export const clearPageMessage = () => {
  window.dispatchEvent(new CustomEvent(CLEAR_MESSAGE_EVENT));
};
